import Modal from "../UI/Modal";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { closeConfirmToggle } from "../../store/reducers/frases/frases.reducer";
import {
  toggleFraseActiveThunk,
  getFrasesThunk,
} from "../../store/reducers/frases/frases.thunks";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const {
    confirmModalOpen,
    toggleFraseId,
    toggling,
    list,
    page,
    search,
    talentoFilter,
    isRandomFilter,
  } = useSelector((state) => state.frases);

  const frase = list.find((f) => f.id === toggleFraseId);

  if (!frase) return null;

  const isActivating = !frase.is_active;

  const handleConfirm = async () => {
    const result = await dispatch(toggleFraseActiveThunk(toggleFraseId));
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getFrasesThunk({ page, search, talento: talentoFilter, isRandom: isRandomFilter }));
    }
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title={isActivating ? "Activar frase" : "Desactivar frase"}
      size="sm"
    >
      <div className="text-center py-3">
        <Icon
          icon={
            isActivating
              ? "mdi:check-circle-outline"
              : "mdi:alert-circle-outline"
          }
          className={`icon text-64 mb-3 ${
            isActivating ? "text-success" : "text-warning"
          }`}
        />
        <p className="mb-4">
          ¿Está seguro que desea {isActivating ? "activar" : "desactivar"} la
          frase <strong>"{frase.frase.substring(0, 50)}..."</strong>?
        </p>
        <div className="d-flex align-items-center justify-content-center gap-3">
          <button
            type="button"
            className="btn btn-outline-secondary px-20 py-11"
            onClick={() => dispatch(closeConfirmToggle())}
            disabled={toggling}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={`btn ${
              isActivating ? "btn-success" : "btn-warning"
            } px-20 py-11`}
            onClick={handleConfirm}
            disabled={toggling}
          >
            {toggling ? "Procesando..." : "Confirmar"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmToggleModal;
